"use client";

import { Icon, OspToast } from "@ospweb/sdk-ui";

import { I18nUtil } from "@utils/i18n";
import Message from "@components/Chat/Message";
import Translations from "@translate/screens/SharePage";
import { cn } from "utils";
import { getReferencePattern } from "../utils/chatUtils/parseChatMessage";
import { useEffect } from "react";
import { useParams } from "next/navigation";
import { useShareMessage } from "@hooks/useShareMessage";

const I18n = I18nUtil.createScoped(Translations);

type ISharePageProps = {
  id?: string;
  isOnlyChat?: boolean;
  className?: string;
};

export const SharePage = (props?: ISharePageProps) => {
  const params = useParams();
  const paramsId = params?.id as string;
  const { id, isOnlyChat, className } = props || {};
  const { messages, ContinueChat, error } = useShareMessage({
    id: id || paramsId,
  });
  const firstUserContent =
    messages &&
    !!messages.length &&
    messages?.[0]?.role === "user" &&
    messages?.[0]?.content;

  const parsedFirst = getReferencePattern(firstUserContent || "");
  const questionContent =
    parsedFirst?.question || parsedFirst?.referenceContent;

  useEffect(() => {
    if (!error) {
      return;
    }
    const errMsg =
      error?.code === 70003
        ? I18n.t("Something went wrong. Please check if the link is correct.")
        : error?.msg;
    OspToast.error({
      content: errMsg,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error?.code]);

  return (
    <div
      className={cn("min-h-screen text-content_primary w-full px-4", className)}
    >
      {!isOnlyChat && (
        <div className="flex justify-between items-center w-full gap-6 md:py-6 py-4 sticky top-0 bg-background_solid_secondary md:border-b md:border-background_white_overlay10 z-10 headline_regular_m">
          <span className="truncate">
            {questionContent || "Conversations from shared"}
          </span>
        </div>
      )}
      <main
        aria-label="Share Page main"
        data-openreplay-label="misc_sharepage_main"
        id="sem-share-page-main"
        className="relative min-h-[calc(100vh-240px)] mx-auto max-w-[900px]"
      >
        {messages &&
          !!messages.length &&
          (messages?.[0]?.role === "assistant" || messages.length > 1) &&
          messages.map((item, index) => {
            return (
              <Message
                key={item.messageId}
                data={item as any}
                isAction={false}
                reload={() => {}}
                messageId={item.messageId || ""}
                chatId={item.chatId || ""}
                prevIsUser={messages[index - 1]?.role === "user"}
                shareId={id || paramsId}
                currentIndex={index}
                isOnlyChat={isOnlyChat}
              />
            );
          })}
      </main>
      {!isOnlyChat && messages && !!messages.length && (
        <div className="sticky bottom-0 md:py-6 pt-4 pb-8 px-4 flex justify-end items-center bg-background_solid_secondary z-2 mx-[-16px] w-[calc(100%+32px)]">
          <button
            type="button"
            data-openreplay-label="misc_sharepage_share"
            className={cn("button sm_button primary_button button_m")}
            onClick={ContinueChat}
          >
            <Icon name="chat" size={20} className="mr-1" />
            <span>{I18n.t("Continue chatting")}</span>
          </button>
        </div>
      )}
    </div>
  );
};
